var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`paragraph paragraph-align-${_vm.align}`,style:(_vm.paragraphStyle)},[_c('div',{staticClass:"paragraph-container"},[_c('div',{staticClass:"paragraph-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }